import { ScreenProps } from "../../../components-common/_types";
import { KvpProvider } from "../../_temporary/kvp-provider";
import { IScreenProvider } from "../_types";

export class ScreenPropsProvider extends KvpProvider<ScreenProps> implements IScreenProvider{
}
